const PRIVATE_TRANSFER_STORAGE_PREFIXES = ['box_truck_browser_handoff:'] as const

/** Remove private, short-lived transfer records when the operator explicitly logs out. */
export const clearPrivateTransferStorage = (): void => {
    try {
        const keys = Array.from({ length: localStorage.length }, (_, index) => localStorage.key(index))
        for (const key of keys) {
            if (key && PRIVATE_TRANSFER_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix))) localStorage.removeItem(key)
        }
    } catch {
        // Storage may be blocked. Individual transfer readers must still enforce identity and TTL.
    }
}
